import { render } from "./ConnectionRequests.vue?vue&type=template&id=23c18c9b"
import script from "./ConnectionRequests.vue?vue&type=script&lang=js"
export * from "./ConnectionRequests.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__